import { render, staticRenderFns } from "./navigation-bar.vue?vue&type=template&id=643657a4&scoped=true&"
import script from "./navigation-bar.vue?vue&type=script&lang=js&"
export * from "./navigation-bar.vue?vue&type=script&lang=js&"
import style0 from "./navigation-bar.vue?vue&type=style&index=0&id=643657a4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643657a4",
  null
  
)

export default component.exports